import { render } from "./RegulationsView.vue?vue&type=template&id=e7abbbd8"
import script from "./RegulationsView.vue?vue&type=script&lang=js"
export * from "./RegulationsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__